import ChartMetric from '@/Enums/Chart/Metric.enum';
import InsightCallout from '@/components/InsightCallout';
import { getVerticalFootTrafficGraphData } from '@/helpers/attribution/chartData';
import { selectFootTrafficPeakDayInsight } from '@/helpers/attribution/footTrafficInsights';
import { downloadCSV } from '@/helpers/downloadCSV';
import { useAppSelector } from '@/store/hooks';
import { selectFootTrafficWeekdayReport } from '@/store/selectors/attribution/footTraffic.selectors';
import { useCallback, useMemo } from 'react';
import VerticalChart from '../Charts/VerticalChart';
import GraphCard from './BaseCard/GraphCard';

const label = 'Day of Week';

const WeekdayCard = () => {
  const { loading, weekdayReport } = useAppSelector(selectFootTrafficWeekdayReport);
  const { text: insightText } = useAppSelector(selectFootTrafficPeakDayInsight);

  const { chartData, csvData } = useMemo(
    () => getVerticalFootTrafficGraphData(weekdayReport, loading),
    [weekdayReport, loading],
  );
  const noData = useMemo<boolean>(() => Object.values(weekdayReport).every(visits => !visits), [weekdayReport]);

  const onDownload = useCallback(() => {
    if (!loading) {
      downloadCSV(csvData, label);
    }
  }, [csvData, loading]);

  return (
    <GraphCard label={label} loading={loading} noData={noData} onDownload={onDownload} allowPrint>
      <VerticalChart chartData={chartData} legendLabel={ChartMetric.FootTrafficVisits} />
      <InsightCallout text={insightText} loading={loading} />
    </GraphCard>
  );
};

export default WeekdayCard;
